<template>
    <!--弹窗-->
    <el-dialog
        width="640px"
        :title="asinInfo.title"
        :visible.sync="visible"
        :before-close="handleClose"
        append-to-body
    >
        <el-input type="textarea" v-model="asinInfo.info" :rows="5"></el-input>

        <span slot="footer" class="dialog-footer">
            <el-button @click="handleClose" type="primary">关 闭</el-button>
          </span>

    </el-dialog>
</template>
<script>

export default {
    data() {
        return {
            asinInfo: {},
            list: [],
        }
    },
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        closeFlag: {
            type: Boolean,
            default: false
        },
        info: {
            type: Object,
            default: {}
        }
    },
    watch: {
        visible: {
            handler(val) {
                if (val) {
                    this.asinInfo = this.info
                }
            },
            deep: true,
            immediate: true
        }
    },
    methods: {
        // 关闭弹窗
        handleClose() {
            this.$emit('close-callback', this.closeFlag)
        }
    }
}
</script>
<style type="text/scss" lang="scss">
.wrapBox {
    width: 600px;
    margin-top: 10px;

    .bottomBox {
        margin-top: 17px;
        display: flex;
        justify-content: center;
    }
}

.download {
    display: flex;
    justify-content: center;
}

.top {
    margin: 0px auto 20px;
    width: 60%;
    display: flex;
    justify-content: space-between;
}
</style>

